<script >
import { ref, computed } from 'vue-demi';
import useSwiper from '../composables/useSwiper';
import useCssVar from '../composables/useCssVar';
import useAutoplay from '../composables/useAutoplay';
// 容器相关
import SwiperSlide from '../children/swiper-slide/render.vue';
import { CHILD } from '../common/constant';
const {
  ComplexComp
} = require('@futuweb/fego-render').plugins;
const innerParentMixin = ComplexComp.Inner.Parent.Mixins({
  [CHILD]: SwiperSlide
});
const __sfc_main = {
  mixins: [innerParentMixin]
};
__sfc_main.props = {
  tpl: Object
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    usePageType
  } = require('@fegobull/webapi').use;
  const {
    isPC
  } = usePageType();
  const props = __props;
  const swiperOptions = computed(() => ({
    loop: props.tpl.props.loop,
    autoplay: props.tpl.props.autoplay,
    slidesPerView: props.tpl.props.slidesPerView,
    spaceBetween: props.tpl.props.spaceBetween,
    centeredSlides: props.tpl.props.centeredSlides,
    slides: props.tpl.children,
    autoplayDelay: props.tpl.props.autoplayDelay
  }));
  const {
    paginationCssVar
  } = useCssVar(props);
  const swiperRef = ref(null);
  const paginationRef = ref(null);
  const {
    swiper
  } = useSwiper({
    el: swiperRef,
    paginationEl: paginationRef,
    options: swiperOptions
  });
  props.tpl.props.autoplay && useAutoplay(swiper, swiperRef);
  return Object.assign({
    isPC,
    paginationCssVar,
    swiperRef,
    paginationRef
  }, {
    swiper
  });
};
export default __sfc_main;
</script>
<template>
    <div :class="['basic-swiper', { pc: isPC }]">
        <div ref="swiperRef" class="basic-swiper-main">
            <div class="swiper-wrapper">
                <!-- 子项 -->
                <div
                    :class="{
                        'swiper-slide': true,
                        'swiper-slide__width-auto': tpl.props.slidesPerView === 'auto'
                    }"
                    v-for="item in tpl.children"
                    :key="item.id"
                >
                    <inner-children-renderer :children="item" />
                </div>
            </div>
            <div ref="paginationRef" :style="paginationCssVar" class="swiper-pagination"></div>
        </div>
    </div>
</template>

<style lang="less" scoped>
@import './index.less';
</style>
<style lang="less">
/* 受内部组件旧版本swiper样式影响，需要全局注入，有父类+css变量作用域控制，不会影响其他swiper */
.basic-swiper {
    .swiper-pagination-bullet {
        width: var(--swiper-pagination-bullet-size);
        height: var(--swiper-pagination-bullet-size);
        background: var(--swiper-pagination-bullet-inactive-color);
    }
    .swiper-pagination-bullet-active {
        background: var(--swiper-pagination-color);
    }
}
</style>
